import { render, staticRenderFns } from "./TitleValueListItem.vue?vue&type=template&id=152b2510&scoped=true"
import script from "./TitleValueListItem.vue?vue&type=script&lang=js"
export * from "./TitleValueListItem.vue?vue&type=script&lang=js"
import style0 from "./TitleValueListItem.vue?vue&type=style&index=0&id=152b2510&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152b2510",
  null
  
)

export default component.exports